import { useCallback } from 'react';
import './style.scoped.css';
import Button from 'src/components/Button';
import { useTranslation } from 'react-i18next';
import { formatMoney, showError } from 'src/utils';
import { createOrderTopUp } from 'src/api';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import LoadingService from 'src/utils/LoadingService';
import paymentSt, { PaymentStore } from 'src/stores/PaymentStore';
import { observer } from 'mobx-react-lite';
import TopUp from '../TopUp';
dayjs.extend(customParseFormat);

interface OtherFeeObserverProps {
  paymentStore?: PaymentStore;
}
const OtherFeeObserver = observer(({ paymentStore } : OtherFeeObserverProps) => {
  const { t } = useTranslation();

  const _handleCheckbox = useCallback((id) => {
    let feeTypes = paymentStore?.otherPaymentInfo?.feeTypes;
    feeTypes = feeTypes ?? [];
    let feeType = feeTypes.find(ft => ft.id == id);
    feeType.checked = !feeType.checked;
  }, [paymentStore]);

  const _handlePayment = async () => {
    if(paymentStore?.topUpPaymentInfo?.errTopUpValue) {
      showError(t('msg_09'));
    } else if(paymentStore?.topUpPaymentInfo?.topUpAmount == 0){
      showError(t('msg_13'));
    }else{
      let request = {
        requestId: paymentStore?.topUpPaymentInfo?.requestId,
        amount: paymentStore?.topUpPaymentInfo?.amount,
        policyNumber: paymentStore?.topUpPaymentInfo?.policyNum,
      }
      try{
        LoadingService.instance.current.open();
        let createOrderRes = await createOrderTopUp(request);
        LoadingService.instance.current.close();
        if (window?.ReactNativeWebView) {
          window?.ReactNativeWebView?.postMessage(
            JSON.stringify({
              type: 'PAYMENT_HUB_TRANSACTION',
              data: createOrderRes?.data,
            })
          );
        }
      }catch (error) {
        LoadingService.instance.current.close();
        showError(error?.response?.data?.error_message);
      }
    }
  };

  return (
    <div className="view-other-fee">
      <div className="max-w-md mx-auto screenScrollContainer">
        <div>
          {/* <div className={"px-4 mb-4 pt-4"}>
            {paymentStore?.otherPaymentInfo?.feeTypes.map(feeType => <div key={feeType.id} className='bg-surface b-radius-4'>
              <Checkbox
                textComponent={
                  <div>
                    <div className="text-base font-bold text-onSurface">
                      {t('pay_fee_addition_1')}
                    </div>
                  </div>
                }
                checked={feeType.checked}
                onCheck={() => _handleCheckbox(feeType.id)}
                changeBackground={false}
                type="card"
              />
            </div>)}
          </div> */}
          <div>
            <TopUp />
          </div>
        </div>
      </div>
      <div className="bottomButtonBlock">
        <div className='border border-line'>
          <div className="flex flex-row pt-1 pl-4 pr-4 pb-4 bg-surface">
            <div className="flex-1 smallTitle2">{t('total_fee')}</div>
            <div className="blockTitlePrimary">
              {formatMoney(paymentStore?.topUpPaymentInfo?.amount) + ` ${paymentStore?.topUpPaymentInfo?.currency ?? ""}`}
            </div>
        </div>
        </div>
        <div className='px-4 pt-3'>
          <Button
            text={t('payment')}
            onClick={_handlePayment}
            extraClassName={'w-full'}
            disabled={Number(paymentStore?.topUpPaymentInfo?.amount) == 0}
          />
        </div>
      </div>
    </div>
  );
});

const OtherFee = () => <OtherFeeObserver paymentStore={paymentSt} />;
export default OtherFee;
